module.exports = __webpack_public_path__ + "a4e1705a8e929a2f809c4c669650cf3f.MP3";